
<template>
  <b-navbar id="navbar-top" fixed-top type="is-light" :close-on-click="false">
        <template slot="brand">
            <b-navbar-item tag="router-link"
                to="/"
                type="is-link">
                <img
                    src="../assets/images/logos/logo-m.png"
                    alt="My Meatloaf Logo"
                >
            </b-navbar-item>
        </template>
        <template slot="start">
        <!--
            <b-navbar-item tag="router-link"
                to="/"
                type="is-link">
                Home
            </b-navbar-item>
        
            <b-navbar-item tag="router-link"
                :to="{ name: 'recipes' }"
                type="is-link">
                Find Recipes
            </b-navbar-item>
             <b-navbar-item tag="router-link"
                :to="{ name: 'Create Recipe' }"
                type="is-link">
                Create Recipe
            </b-navbar-item>
        -->
            <b-navbar-item class="searchbar">
            <b-field grouped position="is-left">
                <b-input 
                type="search" icon="search"
                v-model="searchInput" 
                @keyup.enter.native="search()">
                </b-input>
                <p class="control">
                    <button class="button is-primary" @click="search()">Search</button>
                </p>
            </b-field>
                        </b-navbar-item>
        </template>
        <template slot="end">
            <b-navbar-item tag="div" v-if="!isLoggedIn">
                <div class="buttons">
                <router-link to="/sign-up"
                class="button is-light">
                    <strong>Sign up</strong>
                </router-link>
                <router-link to="/login"
                class="button is-primary">
                    <strong>Log in</strong>
                </router-link>
                </div>
            </b-navbar-item>
                <b-navbar-item tag="div" v-if="isLoggedIn">

                <b-dropdown                
                    position="is-bottom-left"
                    class="notification-dropdown"
                    aria-role="menu" v-if="isLoggedIn">
                    <a @click="simple()"
                        slot="trigger">
                             <b-icon size="is-medium" type="is-dark"
                    icon="bell"></b-icon>
                    <div class="notification-label">
                    <span class="has-text-dark">{{onlyRead.length}}</span>
                    </div>
                    </a>
                <div v-if="onlyRead.length == 0">
                    <b-message>
                        No new notifications.
                    </b-message>                
                </div>
                <div v-else v-for="notification in onlyRead" :key="notification.id">
                    <b-message v-if="notification.type == 'like'" type="is-success">
                        <router-link  :to="{name: 'Kitchen', params: {id: notification.typeId}}">  
                            {{notification.message}}
                        </router-link>                  
                    </b-message>
                    <b-message v-if="notification.type == 'meal'" type="is-info">
                        <router-link  :to="{name: 'meal-alt', params: {id: notification.typeId}}">  
                            {{notification.message}}
                        </router-link>                  
                    </b-message>
                    <b-message v-if="notification.type == 'menu'" type="is-danger">
                        <router-link  :to="{name: 'menu-alt', params: {id: notification.typeId}}">  
                            {{notification.message}}
                        </router-link>                  
                    </b-message>
        </div>
                </b-dropdown>
                <router-link class="button is-primary add-create"
                    :to="{ name: 'Create Recipe' }"
                    type="is-link">
                    <b-icon 
                    icon="plus"></b-icon>
                </router-link>
                <b-dropdown                
                    position="is-bottom-left"
                    class="dash-dropdown"
                    aria-role="menu" v-if="isLoggedIn">
                    
                    <a
                        slot="trigger">
                            <figure 
                            class="user-avatar"
                            v-if="user.image" 
                            :style="{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + user.image + '?alt=media)' }">
                            </figure>
                            
                            <figure class="default-avatar" v-else>                            
                                <img src="../assets/images/logos/hat.png" />
                            </figure>
                    </a>

                    <b-dropdown-item value="Kitchen" has-link aria-role="menuitem">
                        <router-link  :to="{ path: '/kitchen' }" tag="a">
                            <b-icon icon="bread-slice"></b-icon>
                            My Kitchen
                        </router-link>
                    </b-dropdown-item>
                    <b-dropdown-item value="Create Recipe" has-link aria-role="menuitem">
                        <router-link  :to="{ path: '/create-recipe' }" tag="a">
                            <b-icon icon="plus"></b-icon>
                            Create Recipe
                        </router-link>
                    </b-dropdown-item>
                    <!-- <hr class="dropdown-divider" aria-role="menuitem"> -->
                    <b-dropdown-item value="Settings" has-link aria-role="menuitem">
                        <router-link to="/account" tag="a">
                            <b-icon icon="cog"></b-icon>
                            My Account
                        </router-link>
                    </b-dropdown-item>
                    <b-dropdown-item value="logout" aria-role="menuitem"  @click="logout()">
                        <b-icon
                icon="sign-out-alt">
                    </b-icon>
                        Logout
                    </b-dropdown-item>
                </b-dropdown>
                    
                </b-navbar-item>
                
        </template>
    </b-navbar>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import db from '@/db';

export default {
      name: 'Navigation',
// mounted() {
//     console.log(this.isLoggedIn);
// },
    data() {
        return {
            searchInput: null
        }
    },
    computed: {     
        ...mapState('auth', ['user', 'isLoggedIn']),
        onlyRead: function () {
            return this.user.notifications.filter(function (notification) {
                return notification.read == false
            })
        }   
    }, 
    methods: {
      search() {
          if(this.searchInput) {
            this.$router.push({ name: 'Search', query: { query: this.searchInput } })
          }
      },
      simple() {
          for(let i=0;i<this.onlyRead.length;i++) {
              let newNotificationRef = db.collection('users').doc(this.user.id).collection('notifications').doc(this.onlyRead[i].id);
                newNotificationRef.update({
                    read:true,
                });
          }
        
        
      },
     ...mapActions('auth', ['login', 'logout']), 
  }
};

</script>
